export default __webpack_public_path__ + "static/media/CME.d04414ee.svg";